
import { defineComponent, onMounted, ref } from "vue";
import PopupModal from "@/components/modals/popups/PopupModal.vue";
import PopupService from "@/core/services/PopupService";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import ApiService from "@/core/services/ApiService";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { slide } from "@/assets/ts/_utils";
export default defineComponent({
  components: { PopupModal, Swiper, SwiperSlide },
  props: {
    popupId: { type: String, required: true },
  },
  setup(props) {
    const sliders = ref([]);
    const loading = ref(true);
    const showModal = ref(false);
    const sw = ref<null | typeof Swiper>(null);
    const multiple = ref(false);
    const onSwiper = (swiper) => {
      sw.value = swiper;
    };
    onMounted(async () => {
      ApiService.get("account/popup/" + props.popupId)
        .then(({ data }) => {
          if (data) {
            var show = PopupService.shouldShowPopup(
              props.popupId,
              data.showType
            );
            if (show) {
              sliders.value = data.popupItems;
              setTimeout(() => {
                showModal.value = true;
              }, 2000);
              if (data && data.popupItems && data.popupItems.length > 1) {
                multiple.value = true;
                setTimeout(() => {
                  sw.value!.autoplay.start();
                }, 3000);
              }
            }
          }
          loading.value = false;
        })
        .catch(({ response }) => {
          loading.value = false;
        });
    });
    return {
      onSwiper,
      showModal,
      loading,
      sliders,
      sw,
      multiple,
      modules: [Autoplay, Navigation, Pagination],
    };
  },
});
